import { pagePathChanged } from '../general/modules/router/actions';
import { _select, _take, ListenerApiLight } from './listenerMiddleware';
import { Page } from './models/page';
import { getPage } from './modules/app/selectors';

export async function userExitsAnonymousPages(lapi: ListenerApiLight) {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const page = _select(lapi, getPage);
    if (page !== Page.SHARED_FOLDER && page !== null) {
      break;
    }

    await _take(lapi, pagePathChanged);
    lapi.signal.throwIfAborted();
  }
}
